var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHibbertLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 731 86",
    style: {
      enableBackground: "new 0 0 731 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#009BDE;}\n\t.st1{fill:none;stroke:#009BDE;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:#0033A0;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hibbert_CMS_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.8,9.5h6.9v29.6h37.2V9.5h6.9v68.2h-6.9V45.4h-37.2v32.3h-6.9V9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445.7,78.3c-3.1,0-5.2-2.5-5.2-5.2c0-2.7,2.1-5.2,5.2-5.2c3.1,0,5.2,2.5,5.2,5.2 C450.9,75.8,448.7,78.3,445.7,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.4,79.4c-20.3,0-35.5-15.1-35.5-35.8s15.2-35.8,35.5-35.8S530,22.9,530,43.6S514.7,79.4,494.4,79.4z  M494.4,14.1c-17.5,0-28,13.8-28,29.5c0,15.7,10.5,29.5,28,29.5s28-13.8,28-29.5C522.4,27.9,511.9,14.1,494.4,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M543.2,78.3c-3.1,0-5.2-2.5-5.2-5.2c0-2.7,2.1-5.2,5.2-5.2s5.2,2.5,5.2,5.2C548.4,75.8,546.2,78.3,543.2,78.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M594.6,65l23-55.5h10.6v68.2h-6.9v-59h-0.2l-24.7,59h-3.7l-24.7-59h-0.2v59H561V9.5h10.6L594.6,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M646,78.3c-3.1,0-5.2-2.5-5.2-5.2c0-2.7,2.1-5.2,5.2-5.2c3.1,0,5.2,2.5,5.2,5.2 C651.2,75.8,649.1,78.3,646,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M670.8,71.3h36.5v6.4h-43.4V9.5h42.3v6.4h-35.4v23.2h33v6.4h-33V71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M720.3,78.3c-3.1,0-5.2-2.5-5.2-5.2c0-2.7,2.1-5.2,5.2-5.2c3.1,0,5.2,2.5,5.2,5.2 C725.5,75.8,723.4,78.3,720.3,78.3z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 358.6,
    y1: 7.3,
    x2: 358.6,
    y2: 79.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.7,35.2V21.3h15.9v13.9H79.7z M80,78.7V39.3h15.1v39.4H80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.5,79.7c-8,0-13-3.8-16.6-8.2v7.2h-15.1V6.6H118v24.8c3.7-5.1,8.7-9,16.6-9c12.4,0,24.2,10.1,24.2,28.5 v0.2C158.7,69.6,147.1,79.7,134.5,79.7z M143.7,51c0-9.2-6-15.2-13-15.2c-7,0-12.9,6.1-12.9,15.2v0.2c0,9.2,5.9,15.2,12.9,15.2 c7,0,13-6,13-15.2V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.7,79.7c-8,0-13-3.8-16.6-8.2v7.2h-15.1V6.6h15.1v24.8c3.7-5.1,8.7-9,16.6-9c12.4,0,24.2,10.1,24.2,28.5 v0.2C218,69.6,206.3,79.7,193.7,79.7z M202.9,51c0-9.2-6-15.2-13-15.2c-7,0-12.9,6.1-12.9,15.2v0.2c0,9.2,5.9,15.2,12.9,15.2 c7,0,13-6,13-15.2V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.4,56.5h-37c1.5,7.1,6.3,10.8,13,10.8c5.1,0,8.7-1.6,12.9-5.7l8.6,7.9c-5,6.4-12.1,10.3-21.7,10.3 c-16,0-27.8-11.6-27.8-28.5v-0.2c0-15.8,10.8-28.7,26.3-28.7c17.8,0,25.9,14.3,25.9,30v0.2C273.6,54.2,273.5,55.1,273.4,56.5z  M247.7,35c-6.3,0-10.3,4.6-11.5,11.7h22.7C258,39.8,254,35,247.7,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.9,36.9V23.5h-12.5V7h-15.1v16.5H310v-0.2c-8.9-0.4-13.7,3.7-16.8,11.3V23.5h-15.1v55.2h15.1V58.3 c0-13.2,6-21.3,16-21.3h0.8v-0.1h6.3V63c0,12.8,6.3,16.6,15.5,16.6c5.1,0,8.7-1.2,11.9-3.2V63.9c-2.2,1.2-4.7,2-7.4,2 c-3.4,0-4.9-1.7-4.9-5.4V36.9H343.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.4,6.7v29.2c5.6-0.3,11.8-0.4,18.6-0.4V6.7H53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.6,40.1V6.7H3v42C3.1,46.2,5.1,44.3,21.6,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.1,39.3C6,39.3,2.8,53.4,3,56.9V78h18.6V55.2c3-6.6,18.7-9.3,31.8-10.4V78h18.6V40.3c0,0,0,0,0,0V39.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.1,39.3C6,39.3,2.8,53.4,3,56.9V78h18.6V55.2c3-6.6,18.7-9.3,31.8-10.4l18.6-1.7c0,0,0-2.9,0-2.9V39.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibbertLogo);
export default __webpack_public_path__ + "static/media/Hibbert_logo.d1031494616487dffd26083b3b3097ae.svg";
export { ForwardRef as ReactComponent };